module.exports = __webpack_public_path__ + "img/KV1.aef79a0f.png";